export default "__VITE_ASSET__CHVtX_iZ__"